module.exports = __webpack_public_path__ + "img/traffic.a0c7981b.png";